module.exports = __webpack_public_path__ + "img/alarm.9dc13dfe.svg";